import advancedFireCalculatorContent from '@/content/seo/advanced-fire-calculator-content.md?raw';
import budgetPlannerContent from '@/content/seo/budget-planner-content.md?raw';
import coastFireCalculatorContent from '@/content/seo/coast-fire-calculator-content.md?raw';
import compoundInterestCalculatorContent from '@/content/seo/compound-interest-calculator-content.md?raw';
import debtPayoffContent from '@/content/seo/debt-payoff-content.md?raw';
import emergencyFundContent from '@/content/seo/emergency-fund-content.md?raw';
import fireCalculatorContent from '@/content/seo/fire-calculator-content.md?raw';
import equityCalculatorContent from '@/content/seo/equity-calculator-content.md?raw';
import jobOfferComparisonContent from '@/content/seo/job-offer-comparison-content.md?raw';
import mortgageCalculatorContent from '@/content/seo/mortgage-calculator-content.md?raw';
import paycheckCalculatorContent from '@/content/seo/paycheck-calculator-content.md?raw';
import rentVsBuyContent from '@/content/seo/rent-vs-buy-content.md?raw';
import retirementGoalCalculatorContent from '@/content/seo/retirement-goal-calculator-content.md?raw';

const seoContentByCanonicalPath: Record<string, string> = {
  '/': fireCalculatorContent,
  '/advanced-calculator': advancedFireCalculatorContent,
  '/coast-fire-calculator': coastFireCalculatorContent,
  '/compound-interest': compoundInterestCalculatorContent,
  '/retirement-goal-calculator': retirementGoalCalculatorContent,
  '/budget-planner': budgetPlannerContent,
  '/debt-payoff': debtPayoffContent,
  '/emergency-fund': emergencyFundContent,
  '/mortgage-calculator': mortgageCalculatorContent,
  '/paycheck-calculator': paycheckCalculatorContent,
  '/rent-vs-buy': rentVsBuyContent,
  '/job-offer-comparison': jobOfferComparisonContent,
  '/equity-calculator': equityCalculatorContent
};

export function getCalculatorSeoContent(canonicalPath: string): string | null {
  return seoContentByCanonicalPath[canonicalPath] ?? null;
}
